import TemplateView from "../../../TemplateView"
import CustomCheckbox from '../../../components/customCheckbox/CustomCheckbox'

export default class ColumnRow extends TemplateView {
    constructor({
        id,
        name,
        selected,
        onColumnSelected = () => {},
    }) {
        super()

        this.params = {
            id,
            name,
        }

        this.state = {
            selected: selected,
        }

        this.callbacks = {
            onColumnSelected,
        }

        this.onStatePropertyChanged('selected', (selected) => {this.button.setState({checked: selected})})
    }

    templateHtml() {
        return '<div class="columnRow">' +
               '    <div class="dragIcon"/>' +
               '    <div class="selectionButton"/>' +
               '</div>'
    }

    afterRender() {
        this.button = new CustomCheckbox({
            label: this.params.name,
            onChange: (data) => {this.callbacks.onColumnSelected(this.params.id, data.checked)},
        }).init(this.find('.selectionButton'))

        this.renderInitialState()
    }

    getDraggableEl() {
        return this.find('.dragIcon')
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/ColumnRow.js